export default {
    lang: {
        choose: '语言/Language',
        zhcn: '简体中文',
        zhtw: '繁體中文',
        en: 'English',
        es: 'Español',
        ru: 'Русский',
        de: 'Deutsch',
        changeok: 'Язык интерфейса успешно изменён!',

    },
    btn: {
        ok: 'ОК',
        cancel: 'Отмена',
        cont: 'Продолжить'
    },
    menu: {
        upload: 'Загрузить',
        newfolder: 'Новая папка',
        del: 'Удалить',
        up: 'Выше',
        refresh: 'Обновить',
        dfu: 'DFU'
    },
    status: {
        connected: 'Подключено. Версия ПО: ',
        version: 'Версия:',
        mac: 'MAC-адрес: ',
        loading: 'загрузка…'
    },
    conn: {
        connect: 'Подключиться',
        connecting: 'Подключение…',
        disconnect: 'Отключиться',
        consuccess: 'Успешное подключение к MigFlash!',
        disconnected: 'MigFlash отключён!',
        connfailed: 'Ошибка подключения к MigFlash!'
    },
    labels: {
        name: 'Имя',
        size: 'Размер',
        type: 'Тип',
        remark: 'Заметка'
    },
    contxmenu: {
        del: 'Удалить…',
        rename: 'Переименовать…',
        prop: 'Свойства…',
        format: 'Отформатировать…'
    },
    properties: {
        title: 'Свойства',
        remark: 'Заметка:',
        entermsg: 'Задайте заметку',
        attrib: 'Атрибуты',
        hide: 'Скрытый',
        errupdate: 'Ошибка обновления свойств',
        remarktoolong: 'Заметки могут быть длиной до 90 байт (то есть 90 символов или 30 китайских символов). Текущее значение: ',
        remarktoolongend: ' байт.'
    },
    upload: {
        title: 'Загрузка',
        drag: 'Перетащите файлы сюда или ',
        click: 'выберите файлы.',
        maxsize: 'Общая длина пути к файлу не должна превышать 63 байта.',
        maxname: 'Имя файла не должно превышать 47 байт.',
        closetitle: 'Закрыть окно загрузчика файлов?',
        closemessage: 'Закрытие окна загрузчика файлов приведёт к удалению списка загрузок и прервёт выполнение текущей очереди загрузки.',
        errupload: ' Ошибка загрузки: '
    },
    format: {
        title: 'Форматирование',
        messrow1a: 'Отформатировать «',
        messrow1b: '»?',
        messrow2: 'Форматирование приведёт к удалению всех данных. Это действие необратимо.',
        messrow3: 'Процесс форматирования может занять до 10 секунд, наберитесь терпения.',
        formatok: 'Форматирование завершено',
        formaterr: 'Ошибка форматирования: '
    },
    del: {
        title: 'Удаление',
        message: 'Удалить «',
        messageend: '»?',
        error: 'Ошибка удаления: ',
        deleteok: 'Удаление успешно завершено'
    },
    dfumode: {
        title: 'Режим DFU',
        startconfirm: 'Войти в режим DFU?',
        updateconfirm: 'Вход в режим DFU выполнен успешно. Открыть страницу обновления программного обеспечения (ПО) через DFU?',
        updatetitle: 'Устройство в режиме DFU'
    },
    oldfirm: {
        title: 'Советы по обновлению ПО',
        message: 'Программное обеспечение (ПО) устройства слишком старое. Для использования функции загрузки обновите ПО до последней версии.'
    },
    newfolder: {
        title: 'Новая папка',
        message: 'Задайте название папки:',
        newfoldererr: 'Ошибка создания папки: '
    },
    rename: {
        title: 'Переименование',
        message: 'Задайте новое имя:',
        errrename: 'Ошибка переименования: ',
        nametoolong: 'Максимальная длина пути к файлу не должна превышать 63 байта.',
        pathtoolong: 'Максимальная длина имени файла не должна превышать 47 байт.'
    },
    drive: {
        message: '(Диск недоступен [код ошибки: ',
        messageend: '])'
    }
}



// WEBPACK FOOTER //
// ./src/i18n/ru_RU.js